import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebase";

const FALLBACK = {
  blouse: ["cotton silk", "raw silk", "georgette"],
  shirt: ["cotton", "linen", "cotton blend"],
  gown: ["crepe", "georgette", "satin"],
  dress: ["crepe", "georgette", "satin"],
};

const text = value => String(value || "").trim().toLowerCase();
const metadata = item => { try { return JSON.parse(item.sectionId || "{}"); } catch { return {}; } };
const stockOf = item => { const value = item.stockQuantity ?? item.availableQuantity ?? metadata(item).stock; const number = Number(value); return Number.isFinite(number) ? number : null; };
const quantityFor = garment => text(garment).includes("blouse") ? 1.25 : text(garment).includes("shirt") ? 2.25 : /(gown|dress)/.test(text(garment)) ? 4 : 2.5;

export function listenToFabricCompatibility({ design = {}, garmentName = "" }, onSuccess, onError) {
  let types = [], fabrics = [];
  const emit = () => {
    const defaultRequiredQuantity = quantityFor(garmentName);
    const configured = Array.isArray(design.recommendedFabricTypeIds) ? design.recommendedFabricTypeIds : [];
    const garmentKey = Object.keys(FALLBACK).find(key => text(garmentName).includes(key));
    const fallbackNames = FALLBACK[garmentKey] || ["cotton", "linen", "silk blend"];
    const selectedTypes = configured.length ? configured.map(id => types.find(type => type.id === id)).filter(Boolean) : fallbackNames.map(name => types.find(type => [text(type.name), ...(type.aliases || []).map(text)].includes(name)) || { id: "", name, aliases: [name], legacy: true });
    onSuccess(selectedTypes.map(type => {
      const aliases = [text(type.name), ...(type.aliases || []).map(text)];
      const configuredRequirement = (design.fabricRequirements || []).find(item => String(item.fabricTypeId || "") === type.id);
      const requiredQuantity = Number(configuredRequirement?.quantity) > 0 ? Number(configuredRequirement.quantity) : defaultRequiredQuantity;
      const products = fabrics.filter(item => item.isActive !== false && ((type.id && item.fabricTypeId === type.id) || (!item.fabricTypeId && aliases.some(alias => text(`${item.name} ${item.categoryId} ${item.sectionId}`).includes(alias)))));
      const availableProducts = products.filter(item => stockOf(item) == null || stockOf(item) >= requiredQuantity);
      return { typeId: type.id, name: type.name, requiredQuantity, products, availableProducts, available: availableProducts.length > 0, reason: products.length ? "Out of stock for the required quantity" : "Not currently stocked" };
    }));
  };
  const stopTypes = onSnapshot(collection(db, "fabric_types"), snap => { types = snap.docs.map(doc => ({ id: doc.id, ...doc.data() })).filter(item => item.isActive !== false); emit(); }, onError);
  const stopFabrics = onSnapshot(collection(db, "fabrics"), snap => { fabrics = snap.docs.map(doc => ({ id: doc.id, ...doc.data() })); emit(); }, onError);
  return () => { stopTypes(); stopFabrics(); };
}
